module.exports = __webpack_public_path__ + "static/media/springleaf.4141bc99.webp";